import createBlockInputSection from './helpers/createBlockInputSection';
import ContainerYieldSidebar from './special-inputs/ContainerYieldSidebar';

const ContainerYieldSidebarForm = createBlockInputSection({
  title: 'Template content',
  inputs: [ContainerYieldSidebar],
});

export default ContainerYieldSidebarForm;
